import {AfterViewInit, Directive, ElementRef, Input, OnInit, Renderer2} from '@angular/core';


/**
 * Width directive change the width of the html element
 * Its goal is to avoid the multitude of class css creation
 * Exemple :
 * <div witdh=100%></div>
 */
@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[minWidth]',
})
export class WizMinWidthDirective implements OnInit {

  @Input() minWidth: string;

  constructor(private elementRef: ElementRef, private  renderer: Renderer2) {
  }
  ngOnInit(): void {
    try {
      this.renderer.setStyle(this.elementRef.nativeElement, 'min-width', this.minWidth);
    } catch(e: any) {
      console.log('bad minWidth', this);
    }

  }
}
